import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Button from 'components/common/Button';

const ClickableItem = ({
  href, innerText, id, target, subTextKey,
}) => {
  const className = cx({
    'contacts-item': true,
    [`contacts-item--${id}`]: id,
  });
  return (
    <div className={className}>
      <a className="contacts-item__link" href={href} target={target}>
        {innerText}
      </a>
      {subTextKey && (
        <span className="contacts-item__text">
          <FormattedMessage id={subTextKey} />
        </span>
      )}
    </div>
  );
};

ClickableItem.propTypes = {
  href: PropTypes.string,
  innerText: PropTypes.string,
  id: PropTypes.string,
  target: PropTypes.string,
  subTextKey: PropTypes.string,
};

ClickableItem.defaultProps = {
  target: '_self',
};

class PageFooter extends Component {
  constructor() {
    super();
    this.state = {
      isWarningOpened: false,
    };
    this.toggleWarningVisibility = this.toggleWarningVisibility.bind(this);
  }

  toggleWarningVisibility() {
    this.setState((prevState) => ({
      isWarningOpened: !prevState.isWarningOpened,
    }), () => window.scrollTo(0, document.body.scrollHeight));
  }

  render() {
    const { intl, showChat, params } = this.props;

    if (SELF_SERVICE) {
      const pageFooterClasses = cx({
        'page-footer': true,
        'page-footer--with-liveagent': showChat,
      });
      return (
        <footer className={pageFooterClasses}>
          <div className="container">
            <div className="grid">
              <div className="grid__item one-half palm-one-whole">
                <ClickableItem
                  id="faq"
                  href={intl.formatMessage({ id: 'footer.support.faq.url' })}
                  innerText={intl.formatMessage({ id: 'footer.support.faq' })}
                  subTextKey="footer.support.faq.text"
                  target="_blank"
                />
              </div>
              <div className="grid__item one-half palm-one-whole">
                <p className="page-footer__copyright-text">
                  <FormattedMessage id="selfservice.footer.ipf-copyrights" />
                </p>
              </div>
            </div>
          </div>
        </footer>
      );
    }

    const email = intl.formatMessage({ id: 'footer.support.email' });
    const supportPhone = intl.formatMessage({ id: 'footer.support.phone' });
    const warningClasses = cx({
      grid: true,
      'grid--center': true,
      'borrowing-warning': true,
      'borrowing-warning--open': this.state.isWarningOpened,
    });

    return (
      <footer className="page-footer">
        <div className="container container--mobile-fullWidth">
          <div className="page-footer__items">
            <p className="page-footer__item page-footer__item--title">
              <FormattedMessage id="footer.company" />
            </p>
            <div className="page-footer__item page-footer__item--contacts">
              <ClickableItem
                id="phone"
                href={`tel:${supportPhone}`}
                innerText={supportPhone}
              />
              <ClickableItem
                id="email"
                href={`mailto:${email}`}
                innerText={email}
              />
              {
                COUNTRY === 'FI' && (
                  <div className="page-footer__item page-footer__item--privacy-notice">
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href={intl.formatMessage({ id: (EMBEDDED && params.partnerID === 'creditea') ? 'privacy.notice.link_creditea' : 'privacy.notice.link' })}
                    >
                      {intl.formatMessage({ id: 'privacy.notice.text' })}
                    </a>
                  </div>
                )
              }
            </div>
            {COUNTRY === 'AU'
              && (
              <Button
                btnType="secondary"
                icon="warning"
                type="button"
                onClick={this.toggleWarningVisibility}
              >
                <FormattedMessage id="footer.warning.btn" />
              </Button>
              )}
          </div>
          {COUNTRY === 'AU'
            && (
            <div className={warningClasses}>
              <div className="grid__item five-ninths palm-one-whole">
                <FormattedHTMLMessage id="footer.warning.text" />
              </div>
            </div>
            )}
        </div>
      </footer>
    );
  }
}

PageFooter.propTypes = {
  intl: PropTypes.object,
  params: PropTypes.object,
  showChat: PropTypes.bool,
};

PageFooter.defaultProps = {
  showChat: false,
};

export default PageFooter;
